export const PAGE_GAP_PX = 12;
export const LINE_SAFETY_PX = 4;




